module.exports = __webpack_public_path__ + "static/img/4.883182e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/eng/4.png
// module id = olfi
// module chunks = 0